import { get, post } from 'pc-sales/utils/http';
import team, { TeamApi } from './team';
import clue, { ClueApi } from './clue';

export { TeamApi, ClueApi };

export class SalesApi {
    team = team; // 销售团队
    clue = clue; // 销售线索

    // 获取销售列表
    get = async (
        data: {
            page?: number;
            pagesize?: number;
            uuid?: string;
            node?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/sales/account', data, { signal: options?.signal });

    // 获取销售账户信息
    info = (data: {
        uuid: string;
        isDecrypt?: boolean; // 是否解密
    }) => get('/v2/sales/account/show', data);

    // 更新销售账户信息
    update = async (data: { uuid: string; teams?: string }) => await post('/v2/sales/account/update', data);

    // 创建销售账户
    create = (data: {
        firstname: string;
        lastname: string;
        uemail: string;
        phone: Array<string>;
        account_currency: string;
        uroleid: string;
        teams?: string;
    }) => post('/v2/user/sales/create', data);
}

export default new SalesApi();
